export default __webpack_public_path__ + "static/media/tagline.85ac80f9.png";